//@flow
import { getFormData as apiGetFormData, postForm as apiPostForm } from "./api";
import { getFormUID } from "../../Library";
import withFormDataFetcher from "../../Helper_HOC/withFormDataFetcher";
import FormPageContainer from "./Containers/FormPageContainer";

export default withFormDataFetcher(
  apiGetFormData,
  getFormUID,
  apiPostForm
)(FormPageContainer);
